/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

/* Types */
import { tFilterType } from 'src/redux/reducers/filter'

const Redux = () => {
  
  const dispatch = useDispatch()

  const suche = useSelector(store => store.Filter.suche)
  const clearSuche = () => dispatch({ type: 'updateFilterSuche', payload: '' })

  const filterBrands = useSelector(store => store.Filter.filterBrands)
  const activeBrands = useSelector(store => store.Filter.activeBrands)
  
  const unsetBrand = (brand: number) =>
    dispatch({ type: 'unsetBrand', payload: brand })

  
  const filterTree = useSelector(store => store.Filter.filterTree)
  const activeFilters = useSelector(store => store.Filter.activeFilters)

  const unsetFilterOption = (filter: {
    filter: number
    option: number
    type: tFilterType
  }) => dispatch({ type: 'unsetFilterOption', payload: filter })
  

  return {
    suche,
    clearSuche,

    filterBrands,
    activeBrands,
    unsetBrand,

    filterTree,
    activeFilters,
    unsetFilterOption,
  }
}

export default Redux
